import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Dropdown } from 'semantic-ui-react'

import './StageSelector.css'

class StageSelector extends PureComponent {
  onStageChange = (event, { value }) => this.props.onChange(this.props.stages.find((s) => s.id === value))

  render() {
    const { printable, stage, stages } = this.props
    const options = [
      {
        key: 'tournament',
        text: 'Reclasificación',
        value: '0',
      },
    ].concat(
      stages.map((s) => ({
        key: s.id,
        text: s.name,
        value: s.id,
      })),
    )

    if (printable) {
      const option = options.find((opt) => opt.key === (stage?.id || 'tournament'))
      return <h4>{option.text}</h4>
    }
    return (
      <Dropdown
        className="StageSelector__dropdown"
        fluid
        name="StageSelection"
        onChange={this.onStageChange}
        options={options}
        placeholder="Fases"
        search={options.length >= 30}
        selection
        value={stage?.id || '0'}
      />
    )
  }
}

StageSelector.propTypes = {
  stages: PropTypes.array.isRequired,

  onChange: PropTypes.func,
  printable: PropTypes.bool,
  stage: PropTypes.object,
}

StageSelector.defaultProps = {
  onChange: Function.prototype,
  printable: false,
  stage: null,
}

export default StageSelector
